import React, { useState, useEffect } from "react";
import { injectStripe, CardNumberElement, CardExpiryElement, CardCvcElement } from "react-stripe-elements";
import Spinner from "react-bootstrap/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addPaymentMethod } from "../../../../../api/payment_methods";
import { subscribeToPrimo, updateCurrentUser } from "../../../../../api/users";
import { updateCurrentUserRedux } from "../../../../../api/helper";
import { useMediaQuery } from "react-responsive";
import { listCountries } from "../../../../../api/location";
import RadioButtons from "../../../Upload/UploadComponents/RadioButtons";
import PrimoInfo from "../PrimoInfo";
import states from "../../../../../public/locals/states.json";

const style = {
  base: {
    color: "#1a1a1a",
    fontFamily: '"Noir Pro", sans-serif',
    fontWeight: 500,
    fontSmoothing: "antialiased",
    fontSize: "16px",
    lineHeight: "21px",
    "::placeholder": {
      color: "#dadada",
      fontFamily: '"Noir Pro", sans-serif',
      fontWeight: 500,
      fontsize: "16px",
      lineheight: "21px",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};

const mystyle = {
  fontWeight: 300,
  fontSize: "12px",
  lineHeight: "24px",
  letterSpacing: "0.1px",
  textAlign: "left",
};

const PrimoCheckoutForm = (props) => {
  console.log("albert beginning", props.current_user);
  const [countries, setCountries] = useState("");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(props.current_user.address.country);
  const [province, setProvince] = useState(props.current_user.address.state);
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 991px)",
  });
  const [showFullList, setFullList] = useState(false);
  console.log("albert123", props.current_user);
  useEffect(() => {
    const rootElement = document.getElementById("root");
    rootElement?.classList.add("overflow-hidden");
    listCountries(["name", "alpha2Code"]).then(({ data }) => {
      let countries = data.data.sort((a, b) => (a.name === "United States of America" ? -1 : 0));
      countries = countries.map((c) => ({
        ...c,
        name: c.alpha2Code === "GB" ? "United Kingdom" : c.name,
      }));
      setCountries(countries);
    });
    return () => rootElement?.classList.remove("overflow-hidden");
  }, []);
  const renderStateProvince = () => {
    return selectedCountry === "United States of America" || selectedCountry === "USA" ? (
      <div>
        <select
          className="custom-select hv-select"
          name="address_attributes[state]"
          value={province}
          onChange={({ target: { value } }) => setProvince(value)}
        >
          <option disabled>State</option>
          {states.map((state) => (
            <option key={state.abbreviation} value={state.abbreviation}>
              {state.name}
            </option>
          ))}
        </select>
      </div>
    ) : (
      <input
        onChange={({ target: { value } }) => setProvince(value)}
        type="text"
        name="address_attributes[state]"
        className="form-control"
        placeholder="State"
      />
    );
  };
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      phoneNumber: "+" + props.current_user.phone_number.code + " " + props.current_user.phone_number.number,
      address_1: props.current_user.address.address_1,
      address_2: props.current_user.address.address_2,
      city: props.current_user.address.city,
      state: props.current_user.address.state,
      zipCode: props.current_user.address.zip,
      country: props.current_user.address.country,
      paypal_me_tag: props.current_user?.artist_profile?.paypal_me_tag,
      billing_frequency: "year",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required(),
      last_name: Yup.string().required(),
      address_1: Yup.string().required(),
      city: Yup.string().required(),
      state: Yup.string().required(),
      zipCode: Yup.string().required(),
      country: Yup.string().required(),
      phoneNumber: Yup.string().required(),
      paypal_me_tag: Yup.string().required(),
      billing_frequency: Yup.string().required(),
    }),
    onSubmit: async (values) => {
      console.log("values =>", values);
      try {
        setLoading(true);
        setError(null);
        let { paymentMethod } = await props.stripe.createPaymentMethod({
          card: props.elements.getElement("cardNumber"),
          type: "card",
          billing_details: {
            phone: values.phoneNumber,
            email: values.email,
            name: values.first_name + " " + values.last_name,
            address: {
              line1: values.address_1,
              line2: values.address_2,
              city: values.city,
              state: province,
              postal_code: values.zipCode,
              country: selectedCountry === "United States of America" ? "US" : selectedCountry,
            }
          },
        });
        console.log("albert_paymentmethod", paymentMethod);
        let {
          data: {
            payment_method: { payment_method_id },
          },
        } = await addPaymentMethod({
          payment_method_id: paymentMethod.id,
          object: paymentMethod,
        });
        await subscribeToPrimo({ payment_method_id, billing_frequency: values.billing_frequency });
        await updateCurrentUser({
          user: {
            artist_profile: {
              paypal_me_tag: values.paypal_me_tag,
            },
          },
        });
        updateCurrentUserRedux();
        props.onCheckoutDone();
      } catch (error) {
        console.log("error => ", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const includedItems = [
    {
      title: "Sasha, your AI Music Manager",
      content: `Tired of trying to find a manager? Look no further, UNIFI Music has you covered with Sasha, your AI Music Manager to help you write social posts, figure out the best places to tour, and more.`,
    },
    {
      title: "TipJar",
      content: `Get tips from anywhere via your UNIFI Music profile. You keep 100% of what you receive.`,
    },
    {
      title: "Unlimited Music Distribution",
      content: `Distribute as much music as you want, straight from your UNIFI Music account.`,
    },
    {
      title: "You keep 100% of your streaming royalties and sales,",
      content: `and all payments are made directly to you via your Paypal address (which you will confirm during the distribution setup process).`,
    },
  ];

  return (
    <>
      {showFullList ? (
        <PrimoInfo onlyBack handleClose={() => setFullList(false)} />
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="intro">
            <h1>Unlock Unlimited Everything with UNIFI Music's PRIMO</h1>
            <div style={{ fontSize: 16.5, marginTop: 15, textAlign: "left" }}>
              Looking to distribute unlimited music to all major digital music platforms, and over 200+ DSPs worldwide in total (and keep all your
              streaming and sales royalties)?
            </div>
            <div style={{ fontSize: 16.5, marginTop: 15, textAlign: "left" }}>
              Need an AI-powered Artist Manager like Sasha to replace that expensive human option you can never find or rely on to help answer all
              your music business questions, help you write social media posts, provide draft contracts, and more? Want to get unlimited, fee-free
              tips and donations from your fans and supporters?
            </div>
            <div style={{ fontSize: 16.5, marginTop: 15, textAlign: "left" }}>
              Awesome...then UNIFI Music's <strong>PRIMO</strong> option is for YOU!
            </div>
            <h2 style={{ fontSize: 25, textAlign: "left", marginTop: 20 }}>What's Included: </h2>
            {includedItems.map(({ title, content }, id) => (
              <div key={id} style={{ textAlign: "left", paddingTop: 15, fontSize: 16.5 }}>
                <strong>{title}</strong>
                {title.endsWith(",") ? <></> : <br />} {content}
              </div>
            ))}
            <div style={{ fontSize: 16.5, marginTop: 15, textAlign: "left" }}>
              Distribute as much music as you want, straight from your UNIFI Music account. (
              <span style={{ textDecoration: "underline", fontSize: 16.5, cursor: "pointer" }} onClick={() => setFullList(true)}>
                See the full list of platforms we distribute to here
              </span>
              )
            </div>
          </div>
          <h3 className="text-green mt-4">
            <div style={{ display: "inline", whiteSpace: "nowrap" }}>$40/month (USD) or </div>{" "}
            <div style={{ display: "inline", whiteSpace: "nowrap" }}>$400/year (USD)</div>
          </h3>
          <small>Cancel any time. Yep, it's that simple. 😃🙌</small>
          <div className="row mt-4">
            {error && (
              <div className="col-100 mb-3">
                {typeof error === "object" && error.length > 0 ? (
                  <small className="text-danger">{error[0]?.message || error[0]}</small>
                ) : (
                  <small className="text-danger">There was an error, Please make sure to enter a valid card details or please try again</small>
                )}
              </div>
            )}
            <div className="col">
              <input
                onChange={handleChange}
                value={values.first_name}
                name="first_name"
                placeholder="First Name"
                className={`form-control ${errors.first_name ? "error" : ""}`}
              />
            </div>
            <div className="col">
              <input
                onChange={handleChange}
                value={values.last_name}
                name="last_name"
                placeholder="Last Name"
                className={`form-control ${errors.last_name ? "error" : ""}`}
              />
            </div>
          </div>

          <div className="row my-3">
            <div className={isMobileDevice ? `col-100 mb-3` : `col-50`}>
              <CardNumberElement style={style} placeholder="Card Number" />
            </div>
            <div className={isMobileDevice ? `col-60` : `col-30`}>
              <CardExpiryElement style={style} />
            </div>
            <div className={isMobileDevice ? `col-40` : `col-20`}>
              <CardCvcElement style={style} />
            </div>
          </div>

          <div className="row">
            <div className="col-50">
              <input
                onChange={handleChange}
                value={values.address_1}
                name="address_1"
                placeholder="Address 1"
                className={`form-control ${errors.address_1 ? "error" : ""}`}
              />              
            </div>
            <div className="col-50">
              <input
                onChange={handleChange}
                value={values.address_2}
                name="address_2"
                placeholder="Address 2(Optional)"
                className="form-control"
              />              
            </div>
          </div>


          <div className="row my-3">
            <div className="col-50">
              <input
                onChange={handleChange}
                value={values.city}
                name="city"
                placeholder="City"
                className={`form-control ${errors.city ? "error" : ""}`}
              />              
            </div>
            <div className="col-50">
              {renderStateProvince()}       
            </div>
          </div>

          <div className="row my-3">
            <div className="col-30">
              <input
                onChange={handleChange}
                value={values.zipCode}
                name="zipCode"
                placeholder="Zip/Postal Code"
                className={`form-control ${errors.zipCode ? "error" : ""}`}
              />              
            </div>
            <div className="col-70">
              <select
                className="custom-select hv-select"
                name="address_attributes[country]"
                id="country"
                value={selectedCountry}
                onChange={({ target: { value } }) => setSelectedCountry(value)}
              >
                {countries &&
                countries
                  .sort((a, b) => (a.name === "United States of America" ? -1 : 0))
                  .map((c) => (
                    <option key={c.alpha2Code} value={c.name}>
                      {c.name}
                    </option>
                  ))}
              </select>              
            </div>
          </div>

          <div className="row my-3">
            <div className="col-50">
                <input
                  onChange={handleChange}
                  value={values.phoneNumber}
                  name="phoneNumber"
                  placeholder="Phone"
                  className={`form-control ${errors.phoneNumber ? "error" : ""}`}
                />              
              </div>
            <div className="col-50">
              <input
                onChange={handleChange}
                value={values.paypal_me_tag}
                name="paypal_me_tag"
                placeholder="Your PayPal Email"
                className={`form-control ${errors.paypal_me_tag ? "error" : ""}`}
              />
              <div style={{ fontSize: 12, paddingTop: 4, paddingLeft: 8, color: "#bbb", textAlign: "left" }}>
                where should we send your streaming & distribution earnings?
              </div>
            </div>
            {!isMobileDevice && <div className="col"></div>}
          </div>
          <div className="d-flex align-items-center justify-content-center" style={{ marginBottom: -40, marginTop: 20 }}>
            <RadioButtons
              selected={values.billing_frequency}
              options={[
                { label: "Monthly ($40/month)", value: "month" },
                { label: "Annually ($400/year, get 2 months free!)", value: "year" },
              ]}
              onChange={handleChange}
              label={`Billing Frequency`}
              name="billing_frequency"
            />
          </div>

          <div className="my-3" style={mystyle}>
            By clicking below, you agree to UNIFI's MUSIC{" "}
            <a href="/terms-of-use" target="_blank">
              Terms of Use
            </a>
            , and have read & understand our{" "}
            <a href="/privacy-policy" target="_blank">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="/eula" target="_blank">
              End User License Agreement
            </a>
            .
          </div>

          <button disabled={loading} className="my-3 text-uppercase btn btn-lg btn-primary">
            {loading ? <Spinner animation="border" variant="light" size="sm" role="status" /> : "Let's do this!"}
          </button>
        </form>
      )}
    </>
  );
};

export default injectStripe(PrimoCheckoutForm);
